import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import { Box, Text } from '@nerdwallet/currency';

import BackgroundColor from '~/client/components/background-color/background-color';
import { stringSelectSpec } from '~/client/lib/editing-configs';

import approvedAboutCopy from './approved-about-copy';

import './about.less';

const About = ({ bgOptions, aboutType }) => {
  const title = get(approvedAboutCopy, `${aboutType}.title`);
  const body = get(approvedAboutCopy, `${aboutType}.body`);
  return (
    <BackgroundColor bgOptions={bgOptions}>
      {(backgroundColor) => (
        <Box
          className="about"
          style={{
            backgroundColor,
            backgroundImage: backgroundColor && 'none',
          }}
        >
          <Box className="about-content">
            <Box className="about-title">
              <Text size="large">{title}</Text>
            </Box>
            <Box className="about-body">
              <Text>{body}</Text>
            </Box>
          </Box>
        </Box>
      )}
    </BackgroundColor>
  );
};

About.propTypes = {
  aboutType: PropTypes.oneOf(['default', 'investing']),
  bgOptions: BackgroundColor.propTypes.bgOptions,
};

About.defaultProps = {
  aboutType: 'default',
  bgOptions: BackgroundColor.defaultProps.bgOptions,
};

About.getEditingConfig = (componentDocument) => [
  ...BackgroundColor.getEditingConfig(componentDocument),
  stringSelectSpec('aboutType', 'Type', [
    { label: 'Default', value: 'default' },
    { label: 'Investing', value: 'investing' },
    { label: 'Marketplace', value: 'marketplace' },
  ]),
];

export default About;
